import React, { Component, Fragment } from 'react';

const XHR = {
  fetch: (method, endpoint, payload, options, callback) => {
    const serialize = (obj) => {
      console.log('Will serialize');
      console.dir(obj);

      if (typeof obj != 'object') {
        console.error('object passed is not object');

        return obj;
      }

      var str = [];
      for (var p in obj) {
        if (obj.hasOwnProperty(p)) {
          str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        }
      }

      return str.join("&");
    };

    const defaultCallback = (result, error) => {
      if (result) {
        console.log('Callback OK');
      } else {
        console.error('XHR error');
        console.dir(error);
      }
    };
    callback = callback || defaultCallback;

    // normalize method
    method = String(method).toUpperCase();

    // payload should be JSON, convert if necessary
    // payload = typeof payload == 'string' ? payload : JSON.stringify(payload);

    // handle headers
    let defaultHeaders = {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': 'application/json',
      'Authorization': ''
    }
    let headers = options && options.headers ? Object.assign(defaultHeaders, options.headers) : defaultHeaders;

    // do actual call
    const controller = new window.AbortController();
    const signal = controller.signal;

    console.log('Swell.Utils.XHR: fetch ' + method + ' ' + endpoint + '...');

    switch (method) {
      case 'GET':
        endpoint += (endpoint.indexOf('?') == -1 ? '?' : '&') + serialize(payload);
        fetch(endpoint, {
          method: 'GET',
          mode: 'cors',
          cache: "no-cache",
          headers,
          body: null,
          signal
        })
        .then((response) => {
          return response.json();
        })
        .then((result) => {
          callback(result, null);
        })
        .catch((error) => {
          switch (error.name) {
            case 'AbortError':
              // just the user cancelling the request, not an actual error
              return;
          }

          callback(null, error);
        })
        break;
      case 'POST':
      case 'PUT':
      case 'DELETE':
       fetch(endpoint, {
          method,
          mode: 'cors',
          cache: "no-cache",
          headers,
          body: payload,
          signal
        })
        .then(result => callback(result, null))
        .catch(error => callback(null, error))
        break;
      default:
        console.error('API method ' + method + ' not supported. Sorry');

        return false;
    }

    return controller;
  },
  abort: (controller) => {
    console.log('Abort via controller');

    return controller.abort();
  }
};

export default XHR;


// WEBPACK FOOTER //
// ./src/components/lib/swell-ui-0.0.3/utils/XHR.js